import { render, staticRenderFns } from "./PublicMembersView.vue?vue&type=template&id=81b9ffec"
import script from "./PublicMembersView.ts?vue&type=script&lang=ts&external"
export * from "./PublicMembersView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports